<template>
  <v-dialog ref="dlgDiklat" v-model="dialog" retain-focus width="500">
    <template v-slot:activator="{}"></template>
    <v-card>
      <v-card-title class="title">Pilih Diklat Lainnya</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row row class="mt-2">
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              autofocus
              v-model="textSearch"
              placeholder="Cari berdasarkan nama Diklat"
              hint
              clearable
              append-icon="mdi-magnify"
              @click:append="pencarian()"
              @keyup.enter="pencarian()"
              @click:clear="pencarian()"
              persistent-hint
              :error-messages="errors.collect('form.instansi')"
            ></v-text-field>
          </v-col>
          <v-col cols="12" class="pa-0" v-if="items.length > 0">
            <v-list-item two-line v-for="item in items" :key="item.id" @click="pilihDiklat(item)">
              <v-list-item-content>
                <v-list-item-title class="title mb-1">
                  <v-list-item-avatar tile size="40" color="teal" class="rounded-lg"
                    ><h3 class="white--text ">D</h3></v-list-item-avatar
                  >
                  {{ item.nama }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col v-else cols="12" class="mx-0 py-0">
            <v-alert type="warning">Data diklat tidak tersedia</v-alert>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      reject: null,
      res: null,
      rej: null,
      instansi: {},
      textSearch: null,
      items: [],
      page: null,
      cp: 1
    };
  },
  mounted() {
    this.current_page = 1;
    this.load;
  },
  methods: {
    // eslint-disable-next-line
    open() {
      this.items = this.cekDiklatAktif();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.res = resolve;
        this.rej = reject;
        this.dialog = true;
      });
    },
    cekDiklatAktif() {
      let diklatAktif = this.$store.getters["diklat/diklat"]
        .filter(diklat => diklat.is_aktif)
        .slice(3, this.$store.getters["diklat/diklat"].length);
      let diklatTerpilih = this.$store.getters["diklat/diklatTerpilih"];

      if (diklatTerpilih) {
        var lists = diklatAktif.filter(x => {
          return x.id != diklatTerpilih.id;
        });
        return lists;
      } else {
        return diklatAktif;
      }
    },
    pencarian() {
      if (this.textSearch) {
        let filteredDiklat = this.cekDiklatAktif().filter(
          item => item.nama.toLowerCase().indexOf(this.textSearch) > -1
        );
        this.items = filteredDiklat;
      } else {
        this.items = this.cekDiklatAktif();
      }
    },
    pilihDiklat(item) {
      this.$store.commit("diklat/setDiklatTerpilih", item);
      this.rej = null;
      this.res(item);
      this.dialog = false;
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    },
    textSearch(v) {
      if (!v) {
        this.items = this.cekDiklatAktif();
      }
    }
  },
  computed: {}
};
</script>
